import { Injectable } from '@angular/core';
import { UnitType } from '../models/enums/unit-type.enum';
import { Measurement } from '../Modules/informate/models/measurement/measurement';
import { ManagementApiService } from './management-api.service';
import Fraction from 'fraction.js';
@Injectable({
    providedIn: 'root',
})
export class MeasurementService {
    constructor(private mgmtSvc: ManagementApiService) {}

    format(inputValue: string, unitType: UnitType, fractionDigits?: number): string {
        let returnValue: string;

        if (inputValue === '' || inputValue === undefined || inputValue === null) {
            returnValue = '';
        } else {
            let unitExt: string;
            let defaultExt: string;
            if (inputValue.includes('/') && unitType !== 3) {
                return '';
            }
            defaultExt = this.mgmtSvc.userDefaults?.find((o) => o.userPreferenceKey == UnitType[unitType])?.userPreference;
            switch (unitType) {
                case UnitType.DefaultAreaUnit:
                    if (defaultExt == 'SqMillimeters') {
                        unitExt = 'mm²';
                    } else if (defaultExt == 'SqMeters') {
                        unitExt = 'm²';
                    } else {
                        unitExt = 'in²';
                    }
                    if (inputValue.toLowerCase().indexOf('mm') != -1) {
                        unitExt = 'mm²';
                    } else if (inputValue.toLowerCase().indexOf('m') != -1) {
                        unitExt = 'm²';
                    } else if (inputValue.toLowerCase().indexOf('in') != -1) {
                        unitExt = 'in²';
                    }

                    break;
                case UnitType.DefaultLengthUnit:
                    unitExt = defaultExt == 'Millimeters' ? 'mm' : '"';

                    // * splitting the number and unit
                    let numericValueString = this.extractNumberFromString(inputValue);
                    let alphabetString = this.extractAlphabetsString(inputValue);

                    // * removing extra whitespace before and after '/'
                    if (inputValue.includes('/')) {
                        numericValueString = numericValueString.trim().replace(/\s*\/\s*/g, '/');
                    }
                    if (inputValue.includes('.') && !inputValue.includes('/')) {
                        numericValueString = numericValueString.replace(/\s+/g, '');
                    }

                    if (this.checkedEnteredValueForLength(inputValue)) {
                        switch (alphabetString) {
                            case 'mm':
                                if (numericValueString.includes('/')) {
                                    return this.convertToMillimeters(numericValueString);
                                } else {
                                    return fractionDigits > 0
                                        ? `${parseFloat(numericValueString).toFixed(fractionDigits)} mm`
                                        : `${parseFloat(numericValueString)} mm`;
                                }
                            case '"':
                                if (numericValueString.includes('.')) {
                                    return `${this.convertDecimalToInch(this.fractionToDecimal(numericValueString))} "`;
                                }
                                return `${numericValueString} "`;
                            case '':
                                if (numericValueString.includes('/') && unitExt === 'mm') {
                                    return this.convertToMillimeters(numericValueString);
                                } else if (numericValueString.indexOf('/') !== -1 && unitExt === '"') {
                                    return `${numericValueString} "`;
                                } else if (numericValueString.indexOf('.') !== -1 && unitExt === '"') {
                                    return `${this.convertDecimalToInch(parseFloat(numericValueString))} "`;
                                } else if (unitExt === '"') {
                                    return `${numericValueString} "`;
                                } else if (unitExt === 'mm') {
                                    return fractionDigits > 0
                                        ? `${parseFloat(numericValueString).toFixed(fractionDigits)} mm`
                                        : `${parseFloat(numericValueString)} mm`;
                                }
                            default:
                                return '';
                        }
                    } else {
                        return '';
                    }

                case UnitType.DefaultTemperatureUnit:
                    unitExt = defaultExt == 'Celcius' ? '°C' : '°F';
                    if (inputValue.toLowerCase().indexOf('f') != -1) {
                        unitExt = '°F';
                    } else if (inputValue.toLowerCase().indexOf('c') != -1) {
                        unitExt = '°C';
                    }
                    break;
                case UnitType.DefaultTorqueUnit:
                    if (defaultExt == 'NewtonMeters') {
                        unitExt = 'Nm';
                    } else if (defaultExt == 'PoundsForceFeet') {
                        unitExt = 'Lbf.ft';
                    } else {
                        unitExt = 'Lbf.in';
                    }
                    if (inputValue.toLowerCase().indexOf('nm') != -1) {
                        unitExt = 'Nm';
                    } else if (
                        inputValue.toLowerCase().indexOf('in') != -1 ||
                        inputValue.toLowerCase().indexOf('"') != -1 ||
                        inputValue.toLowerCase().indexOf("'") != -1
                    ) {
                        unitExt = 'Lbf.in';
                    } else if (inputValue.toLowerCase().indexOf('ft') != -1 && inputValue.toLowerCase().indexOf('lbf') != -1) {
                        unitExt = 'Lbf.ft';
                    }
                    break;
                case UnitType.DefaultForceUnit:
                    if (defaultExt == 'KiloNewtons') {
                        unitExt = 'kN';
                    } else if (defaultExt == 'PoundsForce') {
                        unitExt = 'lbf';
                    } else {
                        unitExt = 'N';
                    }
                    if (inputValue.toLowerCase().indexOf('lb') != -1) {
                        unitExt = 'lbf';
                    } else if (inputValue.toLowerCase().indexOf('kn') != -1) {
                        unitExt = 'kN';
                    } else if (inputValue.toLowerCase().indexOf('n') != -1 && inputValue.toLowerCase().indexOf('k') == -1) {
                        unitExt = 'N';
                    }
                    break;
                case UnitType.DefaultWeightUnit:
                    unitExt = defaultExt == 'Kilograms' ? 'kg' : 'lb';
                    if (inputValue.toLowerCase().indexOf('kg') != -1) {
                        unitExt = 'kg';
                    } else if (inputValue.toLowerCase().indexOf('lb') != -1) {
                        unitExt = 'lb';
                    }
                    break;
                case UnitType.DefaultPressureUnit:
                    unitExt = defaultExt == 'Bar' ? 'Bar' : 'Psi';
                    if (inputValue.toLowerCase().indexOf('bar') != -1) {
                        unitExt = 'Bar';
                    } else if (inputValue.toLowerCase().indexOf('psi') != -1) {
                        unitExt = 'Psi';
                    }
                    break;
                case UnitType.DefaultStressUnit:
                    // if (defaultExt == 'MegaPascals') {
                    //   unitExt = 'MPa';
                    // }
                    // else if (defaultExt == 'PSI') {
                    //   unitExt = 'Psi';
                    // }
                    // else {
                    //   unitExt = 'Bar';
                    // }
                    // if (inputValue.toLowerCase().indexOf('ps') != -1) {
                    //   unitExt = 'Psi';
                    // }
                    // else if (inputValue.toLowerCase().indexOf('mp') != -1) {
                    //   unitExt = 'MPa';
                    // }
                    // else if (inputValue.toLowerCase().indexOf('b') != -1) {
                    //   unitExt = 'bar';
                    // }
                    unitExt = 'MPa';
                    break;
                case UnitType.DefaultPercentageUnit:
                    unitExt = defaultExt = '%';
                    break;
                case UnitType.DefaultAngleUnit:
                    unitExt = defaultExt = '°';
                    //'rad'
                    break;
            }
            //removing due to not doing conversion with decimal points
            // returnValue = parseFloat(inputValue).toFixed(fractionDigits).toString() + ' ' + unitExt;

            if (fractionDigits) {
                let expUnit = this.extractNumberFromString(inputValue);
                let resp = expUnit.split('.');
                if (resp.length == 1 || resp[1].length <= fractionDigits) {
                    returnValue = parseFloat(inputValue).toString() + ' ' + unitExt;
                } else {
                    returnValue = (Math.floor(parseFloat(inputValue) * 100) / 100).toString() + ' ' + unitExt;
                }
            } else {
                returnValue = parseFloat(inputValue).toString() + ' ' + unitExt;
            }

            if (parseFloat(inputValue).toString().toLowerCase() === 'nan') returnValue = '';
        }

        return returnValue;
    }

    extractNumarical(inputValue: string): number {
        let numberPart = parseFloat(inputValue);
        return numberPart;
    }

    getUserPreferedValueWithoutUnit(input: Measurement, unitType: number): number {
        if (input == null || input == undefined) {
            return;
        }
        let numberPart = parseFloat(this.getUserPreferedValue(input, unitType));

        return numberPart;
    }

    getUserPreferedValue(input: Measurement, unitType: number): string {
        if (input == null || input == undefined) {
            return '';
        } else {
            let preferedType: number;
            let userpreference = this.mgmtSvc.userDefaults?.find((o) => o.userPreferenceKey == UnitType[unitType])?.userPreference;
            if (userpreference !== null && userpreference !== undefined) {
                switch (unitType) {
                    case UnitType.DefaultForceUnit:
                        preferedType = userpreference == 'KiloNewtons' ? 0 : 1;
                        break;
                    case UnitType.DefaultAreaUnit:
                        preferedType = userpreference == 'SqMillimeters' ? 0 : 1;
                        break;
                    case UnitType.DefaultLengthUnit:
                        preferedType = userpreference == 'Millimeters' ? 0 : 1;
                        break;
                    case UnitType.DefaultTemperatureUnit:
                        preferedType = userpreference == 'Celcius' ? 0 : 1;
                        break;
                    case UnitType.DefaultTorqueUnit:
                        preferedType = userpreference == 'NewtonMeters' ? 0 : 1;
                        break;
                    case UnitType.DefaultWeightUnit:
                        preferedType = userpreference == 'Kilograms' ? 0 : 1;
                        break;
                    case UnitType.DefaultPressureUnit:
                        preferedType = userpreference == 'Bar' ? 0 : 1;
                        break;
                    case UnitType.DefaultStressUnit:
                        preferedType = userpreference == 'MegaPascals' ? 0 : 1;
                        break;
                }
            } else {
                userpreference = this.mgmtSvc.userDefaults?.find((o) => o.userPreferenceKey == 'DefaultUnits')?.userPreference;
                preferedType = userpreference == 'Metric' ? 0 : 1;
            }

            //METRIC
            if (preferedType == 0) {
                return input?.metric?.stringValue.replace(/,/g, '');
            } //IMPERIAL
            else {
                return input?.imperial?.stringValue.replace(/,/g, '');
            }
        }
    }

    getUserPrefered(input: Measurement): string {
        let unitType: UnitType;
        if (input !== null) {
            switch (input.metric.unit) {
                case 'Millimeters':
                    unitType = UnitType.DefaultLengthUnit;
                    break;
                case 'SqMillimeters':
                    unitType = UnitType.DefaultAreaUnit;
                    break;
                case 'KiloNewtons':
                    unitType = UnitType.DefaultForceUnit;
                    break;
                case 'MegaPascals':
                    unitType = UnitType.DefaultStressUnit;
                    break;
                case 'Bar':
                    unitType = UnitType.DefaultPressureUnit;
                    break;
                case 'Celcius':
                    unitType = UnitType.DefaultTemperatureUnit;
                    break;
                case 'NewtonMeters':
                    unitType = UnitType.DefaultTorqueUnit;
                    break;
                case 'Kilograms':
                    unitType = UnitType.DefaultWeightUnit;
                    break;
                case 'Degrees':
                    unitType = UnitType.DefaultAngleUnit;
                    break;
                case '':
                    break;
            }
        }
        return this.getUserPreferedValue(input, unitType);
    }

    getUserPreferedUnitSuffix(unitType: number): string {
        let unitSuffix: string = '';
        let userpreference = this.mgmtSvc.userDefaults?.find((o) => o.userPreferenceKey == UnitType[unitType])?.userPreference;
        if (userpreference !== null) {
            switch (unitType) {
                case UnitType.DefaultForceUnit:
                    unitSuffix = userpreference == 'KiloNewtons' ? 'kN' : 'lbf';
                    break;
                case UnitType.DefaultAreaUnit:
                    unitSuffix = userpreference == 'SqMillimeters' ? 'mm²' : 'in²';
                    break;
                case UnitType.DefaultLengthUnit:
                    unitSuffix = userpreference == 'Millimeters' ? 'mm' : '"';
                    break;
                case UnitType.DefaultTemperatureUnit:
                    unitSuffix = userpreference == 'Celcius' ? '°C' : '°F';
                    break;
                case UnitType.DefaultTorqueUnit:
                    unitSuffix = userpreference == 'NewtonMeters' ? 'Nm' : 'Lbf.ft';
                    break;
                case UnitType.DefaultWeightUnit:
                    unitSuffix = userpreference == 'Kilograms' ? 'kg' : 'lb';
                    break;
                case UnitType.DefaultPressureUnit:
                    unitSuffix = userpreference == 'Bar' ? 'Bar' : 'Psi';
                    break;
                case UnitType.DefaultStressUnit:
                    unitSuffix = userpreference == 'MegaPascals' ? 'MPa' : 'Psi';
                    break;
                case UnitType.DefaultPercentageUnit:
                    unitSuffix = '%';
                    break;
                case UnitType.DefaultAngleUnit:
                    unitSuffix = '°';
                    //'rad'
                    break;
            }
        }
        return unitSuffix;
    }

    getFormattedPercentage(item: number): string {
        if (item != null) {
            return (item * 100.0).toFixed(2) + ' %';
        }
        return '0.00 %';
    }

    getDisplayedUnit(unit: string, unitType: UnitType) {
        let unitSuffix: string = '';
        switch (unitType) {
            case UnitType.DefaultForceUnit:
                unitSuffix = unit == 'KiloNewtons' ? 'kN' : 'lbf';
                break;
            case UnitType.DefaultAreaUnit:
                unitSuffix = unit == 'SqMillimeters' ? 'mm²' : 'in²';
                break;
            case UnitType.DefaultLengthUnit:
                unitSuffix = unit == 'Millimeters' ? 'mm' : '"';
                break;
            case UnitType.DefaultTemperatureUnit:
                unitSuffix = unit == 'Celcius' ? '°C' : '°F';
                break;
            case UnitType.DefaultTorqueUnit:
                unitSuffix = unit == 'NewtonMeters' ? 'Nm' : 'Lbf.ft';
                break;
            case UnitType.DefaultWeightUnit:
                unitSuffix = unit == 'Kilograms' ? 'kg' : 'lb';
                break;
            case UnitType.DefaultPressureUnit:
                unitSuffix = unit == 'Bar' ? 'Bar' : 'Psi';
                break;
            case UnitType.DefaultStressUnit:
                unitSuffix = unit == 'MegaPascals' ? 'MPa' : 'Psi';
                break;
            case UnitType.DefaultPercentageUnit:
                unitSuffix = '%';
                break;
            case UnitType.DefaultAngleUnit:
                unitSuffix = '°';
                //'rad'
                break;
        }
        return unitSuffix;
    }
    ReducedBoltDiameterformat(inputValue: string, unitType: UnitType): string {
        let returnValue: string;

        if (inputValue === '') {
            returnValue = '';
        } else {
            let unitExt: string;
            let defaultExt: string;
            let Output: string;
            defaultExt = this.mgmtSvc.userDefaults?.find((o) => o.userPreferenceKey == UnitType[unitType])?.userPreference;
            unitExt = defaultExt == 'Millimeters' ? 'mm' : '"';
            if (inputValue.toLowerCase().indexOf('in') != -1 || inputValue.indexOf('"') != -1) {
                unitExt = '"';
            } else if (inputValue.toLowerCase().indexOf('m') != -1) {
                unitExt = 'mm';
            }
            //removing due to not doing conversion with decimal points
            // returnValue = parseFloat(inputValue).toFixed(fractionDigits).toString() + ' ' + unitExt;
            if (inputValue.includes('.') && unitExt == '"') {
                let decimal = parseFloat(inputValue.toString().replace(' mm', '').replace(/ "/g, ''));
                const wholeNumber = Math.floor(decimal);
                const fractionalPart = decimal % 1;
                if (fractionalPart > 0) {
                    const fraction = new Fraction(fractionalPart);
                    const simplifiedFraction = fraction.simplify();
                    //return `${simplifiedFraction.numerator}/${simplifiedFraction.denominator}`;

                    //// Find the greatest common divisor (gcd) of the numerator and denominator
                    //const gcd = this.greatestCommonDivisor(fractionalPart * 100, 100);

                    //// Simplify the fraction by dividing both numerator and denominator by the gcd
                    //const numerator = (fractionalPart * 100) / gcd;
                    //const denominator = 100 / gcd;

                    // Format the mixed fraction as a string
                    const mixedFraction =
                        wholeNumber > 0 ? `${wholeNumber} ${simplifiedFraction.n}/${simplifiedFraction.d}` : `${simplifiedFraction.n}/${simplifiedFraction.d}`;

                    Output = mixedFraction;
                } else {
                    Output = wholeNumber.toString();
                }
            } else {
                Output = inputValue.toString();
            }
            if (Output.includes('"') || Output.includes('mm')) {
                Output = Output.replace(' mm', '').replace(/ "/g, '');
            }
            returnValue = Output.toString() + ' ' + unitExt;
        }

        return returnValue;
    }
    greatestCommonDivisor(a: number, b: number): number {
        if (b === 0) {
            return a;
        }

        return this.greatestCommonDivisor(b, a % b);
    }

    // * helper method which return only numbers from string
    extractNumberFromString(inputValue: string) {
        if (inputValue !== '' && inputValue !== null) return inputValue.replace(/[A-Za-z"]/g, '').trim();
    }

    // * helper method which return only alphabets from string
    extractAlphabetsString(inputValue: string) {
        if (inputValue.indexOf('"') != -1) {
            const regex = /[a-zA-Z"]+/g;
            const matches = inputValue.match(regex);
            return matches ? matches.join('') : '';
        } else {
            const regex = /[a-zA-Z]+/g;
            const matches = inputValue.match(regex);
            return matches ? matches.join('') : '';
        }
    }

    // * helper method to convert fraction to mm
    convertToMillimeters(fraction) {
        const parts = fraction.split(' ');
        if (parts.length == 1) {
            // * this will handle fraction values like 2/5, 1/9 etc...
            const fractionParts = parts[0].split('/');
            const numerator = parseFloat(fractionParts[0]);
            const denominator = parseFloat(fractionParts[1]);
            if (denominator == 0) return '';
            const millimeters = (numerator / denominator) * 25.4;
            return `${millimeters.toFixed(2)} mm`;
        } else if (parts.length == 2) {
            // * this will handle fraction values like 2 2/5, 1 3/5
            const wholeNumber = parseInt(parts[0]);
            const fractionalPart = parts[1];
            const fractionParts = fractionalPart.split('/');
            const numerator = parseInt(fractionParts[0]);
            const denominator = parseFloat(fractionParts[1]);
            if (denominator == 0 || denominator.toString() == 'NaN') return '';
            const inches = wholeNumber + numerator / denominator;
            const millimeters = Math.round(inches * 25.4 * 100) / 100;
            return `${millimeters} mm`;
        } else {
            return '';
        }
    }

    // * helper method to convert decimal to fraction (inches ")
    convertDecimalToInch(decimalNumber: number) {
        // Function to simplify the fraction
        const simplifyFraction = (numerator, denominator) => {
            const gcd = greatestCommonDivisor(numerator, denominator);
            return {
                numerator: numerator / gcd,
                denominator: denominator / gcd,
            };
        };

        const greatestCommonDivisor = (a, b) => {
            if (b === 0) {
                return a;
            }
            return greatestCommonDivisor(b, a % b);
        };

        // Separate the whole number and fractional parts
        const wholeNumber = Math.floor(decimalNumber);
        const fractionalPart = decimalNumber - wholeNumber;

        // Convert the fractional part to sixteenths
        const sixteenths = Math.round(fractionalPart * 16);

        // Simplify the fraction
        const simplifiedFraction = simplifyFraction(sixteenths, 16);

        // Create the mixed fraction string
        let mixedFraction = '';
        if (wholeNumber !== 0) {
            mixedFraction += wholeNumber + ' ';
        }
        if (simplifiedFraction.numerator !== 0) {
            mixedFraction += simplifiedFraction.numerator + '/' + simplifiedFraction.denominator;
        }
        if (decimalNumber == 0) {
            mixedFraction = '0';
        }
        return mixedFraction;
    }

    // * helper method convert decimal to fraction
    fractionToDecimal(fractionValue: string) {
        if (fractionValue.includes(' ')) {
            // Convert mixed number to decimal
            const [wholePart, fractionalPart] = fractionValue.split(' ');
            const [numerator, denominator] = fractionalPart.split('/');
            const decimal = parseFloat(wholePart) + parseFloat(numerator) / parseFloat(denominator);
            return decimal;
        } else {
            // Convert fraction to decimal
            const [numerator, denominator] = fractionValue.split('/');
            if (!denominator) return parseFloat(fractionValue);
            const decimal = parseFloat(numerator) / parseFloat(denominator);
            return decimal;
        }
    }

    // * check if entered string is valid or not for measurement input field
    checkedEnteredValueForLength(inputFieldValue: string) {
        const enteredValue = parseFloat(inputFieldValue).toString();
        let numericValueString = this.extractNumberFromString(inputFieldValue);
        if (enteredValue === 'NaN') {
            return false;
        } else if (numericValueString.split('.').length - 1 > 1 || numericValueString.split('/').length - 1 > 1) return false;
        else return true;
    }
}
